var render, staticRenderFns
import script from "./DefinitionList.vue?vue&type=script&lang=ts&"
export * from "./DefinitionList.vue?vue&type=script&lang=ts&"
import style0 from "./DefinitionList.vue?vue&type=style&index=0&id=d4eabc9e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports